var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slider-item slider-item--top-activities" }, [
    _c("h2", { ref: "title", staticClass: "slider-item__title" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("h3", { ref: "month", staticClass: "slider-item__month" }, [
      _vm._v(_vm._s(_vm.month))
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { ref: "activityList", staticClass: "slider-item__list" },
      _vm._l(_vm.activities, function(item) {
        return _c(
          "li",
          { key: item.label, staticClass: "slider-item__activity" },
          [
            _c("img", {
              attrs: {
                src:
                  "/ressources/logged/img/illustrations/recap2024/slsy-" +
                  item.icon +
                  ".svg",
                alt: "icon",
                width: "48"
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "slider-item__activity-value" }, [
              _vm._v(_vm._s(item.number))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "slider-item__activity-label" }, [
              _vm._v(_vm._s(item.label))
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }